// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"style_pageContainer__3mZnC","policyListItem":"style_policyListItem__2_ZqC"};